import DashboardIcon from '@mui/icons-material/Dashboard'
import PeopleIcon from '@mui/icons-material/People'
import QrCodeIcon from '@mui/icons-material/QrCode'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import ForumIcon from '@mui/icons-material/Forum'
import FlagIcon from '@mui/icons-material/Flag'
import LinkIcon from '@mui/icons-material/Link'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import BarChartIcon from '@mui/icons-material/BarChart'
import AssignmentIcon from '@mui/icons-material/Assignment'
import WorkspacesIcon from '@mui/icons-material/Workspaces'
import { AdminRole } from '../models/User'

export interface RouteItem {
  path: string
  label: string
  icon: React.ReactNode
  requiredRole?: AdminRole[] // 如果未設定，則所有角色都可以存取
}

export const routes: RouteItem[] = [
  {
    path: '/dashboard',
    label: '儀表板',
    icon: <DashboardIcon />,
  },
  {
    path: '/users',
    label: '用戶管理',
    icon: <PeopleIcon />,
  },
  {
    path: '/qr-codes',
    label: 'QR Code 管理',
    icon: <QrCodeIcon />,
  },
  {
    path: '/resources',
    label: '影片管理',
    icon: <LibraryBooksIcon />,
  },
  {
    path: '/discussions',
    label: '討論區管理',
    icon: <ForumIcon />,
  },
  {
    path: '/reports',
    label: '檢舉管理',
    icon: <FlagIcon />,
  },
  {
    path: '/community-links',
    label: '護理世界連結管理',
    icon: <LinkIcon />,
  },
  {
    path: '/analytics',
    label: '數據分析',
    icon: <BarChartIcon />,
  },
  {
    path: '/surveys',
    label: '量表管理',
    icon: <AssignmentIcon />,
  },
  {
    path: '/career-categories',
    label: '職涯分類設定',
    icon: <WorkspacesIcon />,
  },
  {
    path: '/admins',
    label: '人員管理',
    icon: <AdminPanelSettingsIcon />,
    requiredRole: ['super_admin', 'admin', 'senior_assistant'],
  },
]
